import liff from '@line/liff'
import firebase from './firebase';

const init = function(prodMode){
    sessionStorage.setItem('prodMode', prodMode)
    return new Promise((resolve, reject) => {
        if(prodMode == 'true'){
            liff
            .init({
              liffId: "1481726304-VDYe4G0M", // Use own liffId
              withLoginOnExternalBrowser: true, // Enable automatic login process
            })
            .then(() => {
              //start using API
              console.log("LIFF READY");
              //window.location.replace("https://liff.line.me/1481726304-mj2Or86k");
              /*console.log("LANG", liff.getLanguage());
              console.log("VERSION", liff.getVersion());
              console.log("INCLIENT", liff.isInClient());
              console.log("LOGGEDIN", liff.isLoggedIn());
              console.log("OS", liff.getOS());
              console.log("LINEVERSION", liff.getLineVersion());
          
              if (!liff.isLoggedIn() && !liff.isInClient()) {
                window.alert(
                  'To get an access token, you need to be logged in. Tap the "login" button below and try again.'
                );
              } else {
                const accessToken = liff.getAccessToken();
                console.log("ACCESS", accessToken);
                if (liff.isLoggedIn()) {
                  console.log('Your user is', liff.getDecodedIDToken())
                }
              }*/
              resolve()  
            })
            .catch((err) => {
                reject(err)
            });
        }else{
            resolve()
        }
    })
}

const getUser = function () {
    var prodMode = sessionStorage.getItem('prodMode')
    return new Promise((resolve, reject) => {
        if(prodMode =='true'){
            const liffUser = liff.getDecodedIDToken()
            firebase.authenticateUser(liffUser).then(val => {
                resolve(val)
            }).catch(err => {
                reject(err)
            })
        }else{
            const d = new Date()
            resolve({
                uid: `tester_${d.getFullYear()}_${d.getMonth()}_${d.getDate()}`,
                name: `Tester #${d.getFullYear()}_${d.getMonth()}_${d.getDate()}`,
                picture: 'assets/user.png',
                isVoted: false,
            })
        }
    })
}

const isLoggedIn = function(){
    var prodMode = sessionStorage.getItem('prodMode')
    if(prodMode == 'true'){
        return liff.isLoggedIn()
    }else{
        return true
    }
}

export default {
    getUser: getUser,
    isLoggedIn: isLoggedIn,
    init: init
}